module.exports = __webpack_public_path__ + "static/media/glanum_wohnhaus_tn.30545fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_wohnhaus_tn.jpg
// module id = 728
// module chunks = 0